import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MCard from "components/Shared/MCard.tsx";
import { get } from "lodash";
import * as yup from "yup";
import { MinRequiredPasswordLength } from "typeConstants/preferenceTypes";
import { changePassword } from "actions/user";
import { DATA_TYPE_PASSWORD } from "typeConstants/dataTypes";
class ChangePassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disableSave: true,
      newPassword: "",
      confirmNewPassword: "",
    };
    this.handleSave = this.handleSave.bind(this);
    this.validate = this.validate.bind(this);
    this.setCardControls = this.setCardControls.bind(this);
    this.confirmSame = this.confirmSame.bind(this);
    this.validateNewPassword = this.validateNewPassword.bind(this);
    this.printErrorMessage = this.printErrorMessage.bind(this);
    this.onEditFinished = this.onEditFinished.bind(this);
    this.cardControlMethods = null;
    this.errorMessage = "";
  }
  setCardControls(cm) {
    this.cardControlMethods = cm;
  }
  handleSave() {
    const { onChangePassword } = this.props;
    const password = {
      newPassword: get(this.cardControlMethods.getEditedData().find(x => x.key === "newPassword"), "value"),
      oldPassword: get(this.cardControlMethods.getEditedData().find(x => x.key === "oldPassword"), "value"),
    };
    this.props.changePassword(
      password,
      onChangePassword,
    );
  }
  validate(newPassword, confirmNewPassword) {
    return this.validateNewPassword(newPassword) &&
      this.confirmSame(confirmNewPassword) &&
      this.confirmDifferent(newPassword);
  }
  confirmDifferent(value) {
    let oldPassword = this.cardControlMethods.getEditedData().find(x => x.key === "oldPassword");
    return (oldPassword || false) && oldPassword.value !== value;
  }
  confirmSame(value) {
    let newPassword = this.cardControlMethods.getEditedData().find(x => x.key === "newPassword");
    return (newPassword || false) && newPassword.value === value;
  }
  validateNewPassword(password) {
    const { profile } = this.props;
    let newErrorMessage = [];
    if (!password || password.length < MinRequiredPasswordLength) {
      newErrorMessage.push(`Password must be at least ${MinRequiredPasswordLength} characters long`);
    }
    let username = (profile && profile.username) || "";
    if (username.length >= 3 && password.includes(username)) {
      newErrorMessage.push("Password cannot contain the Username");
    }
    let name = [(profile && profile.firstName) || "", (profile && profile.lastName) || ""];
    name.forEach(name => {
      if (name.length >= 3 && password.includes(name)) {
        newErrorMessage.push("Password cannot contain your first or last name");
      }
    });
    const patterns = [/[a-z]/, /[A-Z]/, /[0-9]/, /[!@#$%^&*\(\)_\+\-\={}<>,\.\|\"'~`:;\\?\/\[\]]/];
    let counter = 0;
    patterns.forEach(regex => {
      if (regex.test(password)) {
        counter++;
      }
    });
    if (counter < 3) {
      newErrorMessage.push("Password should have at least one uppercase, one lowercase, one digit or a special character");
    }
    let oldPassword = this.cardControlMethods.getEditedData().find(x => x.key === "oldPassword");
    if (oldPassword && (oldPassword.value === password)) {
      newErrorMessage.push("New password must be different than old password");
    }
    if (newErrorMessage.length) {
      this.errorMessage = newErrorMessage.join("\n, ");
      return false;
    }
    this.errorMessage = "";
    return true;
  }
  onEditFinished(arr, obj) {
    let newPassword = Object.keys(obj).includes("newPassword") ? obj.newPassword : this.state.newPassword;
    let confirmNewPassword = Object.keys(obj).includes("confirmNewPassword") ? obj.confirmNewPassword : this.state.confirmNewPassword;
    if (this.validate(newPassword, confirmNewPassword)) {
      this.setState({ disableSave: false, newPassword: newPassword, confirmNewPassword: confirmNewPassword });
    } else {
      this.setState({ disableSave: true, newPassword: newPassword, confirmNewPassword: confirmNewPassword });
    }
  }
  printErrorMessage() {
    return this.errorMessage;
  }
  render() {
    const { title } = this.props;
    const { disableSave } = this.state;
    return (
      <MCard
        {...{ title }}
        onlyEditable
        getControlMethods={this.setCardControls}
        onEditFinished={this.onEditFinished}
        className={this.props.className}
        actions={[{
          icon: "check",
          helpText: disableSave ? "" : "Save Password",
          onClick: () => !disableSave && this.handleSave(),
          className: disableSave ? "disabled" : "",
        }]}
        fields={[
          {
            key: "oldPassword",
            label: "Old Password",
            dataType: DATA_TYPE_PASSWORD,
            validation: yup.string().required("Old Password is required")
          },
          {
            key: "newPassword",
            label: "New Password",
            dataType: DATA_TYPE_PASSWORD,
            validation: yup.string().required("New Password is required").test({
              name: "validPassword",
              message: this.printErrorMessage,
              test: this.validateNewPassword
            })
          },
          {
            key: "confirmNewPassword",
            label: "Confirm New Password",
            dataType: DATA_TYPE_PASSWORD,
            validation: yup.string().required("Confirm New Password is required").test({
              name: "same",
              message: "New Password and Confirm New Password must be the same",
              test: this.confirmSame
            })
          }
        ]}
      />
    );
  }
}

ChangePassword.defaultProps = {
  onChangePassword: () => { },
  title: "Change Password"
};


ChangePassword.propTypes = {
  profile: PropTypes.object,
  changePassword: PropTypes.func.isRequired,
  onChangePassword: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
};
const mapStateToProps = (state) => {
  return {
    profile: state.user.profile
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    changePassword(password, successCallback) {
      dispatch(changePassword(password, successCallback));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
